import io 			from "socket.io-client";
import connection 	from "@/class/wsConnection"
class websocket extends connection {
	constructor(url, api, settings, ml, EventBus, format, store, helper, info, sockets){
		super(
			url,
			api,
			settings,
			ml,
			EventBus,
			format,
			store,
			helper,
			info,
			sockets,
		);
	}

	init( {channels, key, name, type = "default"}){
		console.log("check init ********************* : ", channels, key, name, type);
		if (!this.sockets[key].connection) {			
			this.sockets[key].connection = io(this.sockets[key].url, this.settings);
			this.sockets[key].connection.emit("start_streaming", key);
			this.sockets[key].count_connections = 1;
			/*channels.forEach((it)=>{
				this.start(it);
			});*/
		}else{
			this.sockets[key].count_connections ++;

		}
	}

	get_channel(key, channel){
		// console.log("CHECK CHANNEL ================== ", key, channel)
		if (this.sockets[key]) {

			return this.sockets[key].connection;
		}
		return null
	}

	channel({key, channel, func, ref},  res){
		// Elimina el listener anterior si existe
		if (this.sockets[key][channel]) {
			this.sockets[key].connection.off(channel, this.sockets[key][channel]);
			this.sockets[key][channel] = null;
		}
		// Registra el nuevo listener
		this.sockets[key][ref].func = func;
		this.sockets[key][channel] = (msg) => {
			res(msg);
		};
		this.sockets[key].connection.on(channel, this.sockets[key][channel]);
	}

	start(item){
		if (item) {
			if (item.channel) {
				return this.sockets
			}
		}
	}

	stop(key, channel){
		// Elimina el listener del canal siempre que exista
		if (this.sockets[key] && this.sockets[key][channel]) {
			this.sockets[key].connection.off(channel, this.sockets[key][channel]);
			this.sockets[key][channel] = null;
		}
	}

	close(key, ref){
		// Limpia todos los listeners asociados antes de desconectar
		if (this.sockets[key] && this.sockets[key].connection) {
			Object.keys(this.sockets[key]).forEach(prop => {
				if (typeof this.sockets[key][prop] === 'function') {
					this.sockets[key].connection.off(prop, this.sockets[key][prop]);
					this.sockets[key][prop] = null;
				}
			});
			this.sockets[key][ref].func = null;
			this.sockets[key].connection.emit("close_streaming",key);
			this.sockets[key].connection.disconnect();
		}
	}

}
export default websocket;
